import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, EventEmitter, computed, input } from "@angular/core";

import { EnabledPipe } from "../../../helpers/enabledpipe/enabledpipe";
import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ModifyL2VPNSpeedPolicer } from "../../../helpers/self-service/modify_l2vpn";
import { ModifyLightPath, ModifyRedundantLightPath } from "../../../helpers/self-service/modify_lightpath";
import { SelfServiceCommand } from "../../../helpers/self-service/self-service-command";
import {
  L2vpnSubscriptionDetails,
  LightPathRedundantSubscriptionDetails,
  LightPathSubscriptionDetails,
} from "../../../pages/subscription-detail/types";
import { SelfserviceWizard } from "../selfservice-wizard/selfservice-wizard";

@Component({
  selector: "selfservice-speedpolicer",
  templateUrl: "selfservice-speedpolicer.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [EnabledPipe, SelfserviceWizard, TranslatePipe],
})
export class SelfserviceSpeedPolicer {
  // TODO: this class does too much. Split up in different classes for different subscription types
  protected subscription = input.required<
    L2vpnSubscriptionDetails | LightPathSubscriptionDetails | LightPathRedundantSubscriptionDetails
  >();
  protected bus = input.required<EventEmitter<StartLoadMessage>>();

  protected speedPolicer = computed(() => this.subscription().speedPolicer);

  protected readonly buildCommand = () => {
    const { type, tag } = this.subscription().product;
    const subscriptionId = this.subscription().subscriptionId;

    if (type === "L2VPN") {
      const modify = new ModifyL2VPNSpeedPolicer();
      modify.subscription = this.subscription() as L2vpnSubscriptionDetails;
      modify.speedPolicer = !this.speedPolicer();
      const action = SelfServiceCommandKeys.ModifyL2VpnSpeedPolicer;
      const command = new SelfServiceCommand(subscriptionId, action);
      command.payload = modify;
      return { command, action };
    } else if (tag === "LP") {
      const modify = new ModifyLightPath();
      modify.subscription = this.subscription();
      modify.speedPolicer = !this.speedPolicer();
      const action = SelfServiceCommandKeys.ModifyLightpath;
      const command = new SelfServiceCommand(subscriptionId, action);
      command.payload = modify;
      return { command, action };
    } else {
      const modify = new ModifyRedundantLightPath();
      modify.subscription = this.subscription();
      modify.speedPolicer = !this.speedPolicer();
      const action = SelfServiceCommandKeys.ModifyRedundantLightpath;
      const command = new SelfServiceCommand(subscriptionId, action);
      command.payload = modify;
      return { command, action };
    }
  };
}
